import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { GlobalStyles } from './styles';
import Sidebar from './components/Sidebar';
import Hamburger from './components/Hamburger';
import Home from './pages/Home';
import Gaming from './pages/Gaming';
import Snowden from './pages/Snowden';
import Videos from './pages/Videos';
import ArticlePage from './pages/ArticlePage';
import Analytics from './pages/Analytics';
import Support from './pages/Support';
import KaspaFuture from './pages/KaspaFuture';
import Checkout from './components/Checkout';
import SnowdenNFTs from './pages/SnowdenNFTs';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import styled from 'styled-components';
import { trackPageView } from './analytics';
import About from './pages/About';
import Radio from './pages/Radio';
import ArchivedArticles from './pages/ArchivedArticles';
import ArchivedArticlePage from './pages/ArchivedArticlePage';

// ────────────────────────────────────────────────
// Styled Componentss
// ────────────────────────────────────────────────
const AppContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const MainContent = styled.main`
  margin-left: 180px;
  flex: 1;
  transition: all 0.3s ease;
  overflow-y: auto;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const TrackPageViews = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

// ────────────────────────────────────────────────
// Main App Component
// ────────────────────────────────────────────────
function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <Router>
      <GlobalStyles />
      <TrackPageViews />

      <AppContainer>
        <Hamburger toggleSidebar={toggleSidebar} isOpen={isOpen} />
        <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />

        <MainContent>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/gaming" element={<Gaming />} />
            <Route path="/snowden" element={<Snowden />} />
            <Route path="/snowden-nfts" element={<SnowdenNFTs />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/kaspa-future-economy" element={<KaspaFuture />} />
            <Route path="/articles/:articleId" element={<ArticlePage />} />
            <Route path="/archived-articles" element={<ArchivedArticles />} />
            <Route path="/archived-articles/:articleId" element={<ArchivedArticlePage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/support" element={<Support />} />
            <Route path="/about" element={<About />} />

            {/* Public admin login route */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected admin routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/analytics" element={<Analytics />} />
              {/* 
                You can add more protected admin routes here in the future, e.g.:
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
              */}
            </Route>
          </Routes>
        </MainContent>
      </AppContainer>
    </Router>
  );
}

export default App;
